// Path: ./src/contextApi/state.ts
import {
  GfAdminUser,
  GfFlyerItemCategory,
  GfPromotionTag,
  GfUnit,
  SignInResponse,
} from "@swagger/typescript-fetch-goflyer";
import { SUPERADMIN } from "../utils/constant/stringConstant";

export const superAdmin = {
  name: SUPERADMIN, //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) this should be from database, not here
  permissions: [
    {
      groupName: "User",
      permissions: [
        {
          name: "view",
          allowed: true,
        },
        {
          name: "create",
          allowed: true,
        },
      ],
    },
    {
      groupName: "Flyer",
      permissions: [
        {
          name: "view",
          allowed: true,
        },
        {
          name: "create",
          allowed: true,
        },
      ],
    },
    {
      groupName: "Deals",
      permissions: [
        {
          name: "view",
          allowed: true,
        },
        {
          name: "create",
          allowed: true,
        },
        {
          name: "edit",
          allowed: true,
        },
      ],
    },
    {
      groupName: "Coupon",
      permissions: [
        {
          name: "view",
          allowed: true,
        },
        {
          name: "create",
          allowed: true,
        },
      ],
    },
    {
      groupName: "Upload",
      permissions: [
        {
          name: "flyer",
          allowed: true,
        },
        {
          name: "menu",
          allowed: true,
        },
      ],
    },
    {
      groupName: "Role",
      permissions: [
        {
          name: "view",
          allowed: true,
        },
        {
          name: "create",
          allowed: true,
        },
      ],
    },
  ],
};
export interface AdminUser extends SignInResponse {
  //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) not good, need to replace with GFAdminUser
  parsedRoles?: {
    name: string;
    permissions: {
      groupName: string;
      permissions: {
        name: string;
        allowed: boolean;
      }[];
    }[];
  };
  jwtToken?: string;
  isLoggedIn: boolean;
}

/**
 * User preferences for advanced search behavior
 */
export interface AdvancedSearchPreferences {
  /**
   * Whether to keep search results visible after creating a flyer item.
   * When false, search results are cleared automatically.
   * Used in CreateFlyerItemPage to determine if search state should be reset.
   */
  keepSearchResults: boolean;
  /**
   * Maximum number of search results to display per page.
   * Used for image search pagination.
   */
  searchLimit: number;
  /**
   * Whether to search in flyer item names (name and nameChinese fields).
   * When enabled, image search will also match against flyer item names.
   */
  searchFlyerItems: boolean;
}

export interface GoFlyerAdminState {
  test: boolean;
  user?: AdminUser | undefined;
  gfAdminUser?: GfAdminUser | undefined;
  promotionTags?: GfPromotionTag[];
  flyerItemCategories?: GfFlyerItemCategory[];
  units?: GfUnit[];
  advancedSearchPreferences: AdvancedSearchPreferences;
}

export const initialGoFlyerAdminState: GoFlyerAdminState = {
  test: true,
  user: undefined,
  gfAdminUser: undefined,
  promotionTags: undefined,
  flyerItemCategories: undefined,
  units: undefined,
  advancedSearchPreferences: {
    keepSearchResults: false,
    searchLimit: 200,
    searchFlyerItems: false,
  },
};
